import { api } from "./api";

export const createRouteApi = (params) => {
    return api.post(`/route/create`, JSON.stringify(params));
};

export const editRouteApi = (params) => {
    return api.post(`/route/edit`, JSON.stringify(params));
};

export const listRouteApi = (params) => {
    return api.get(`/route/list`, { params });
};

export const viewRouteApi = (params) => {
    return api.get(`/route/view`, { params });
};

export const productsRouteListApi = (params) => {
    return api.get(`/route/product-list`, { params });
};

export const completeRouteApi = (params) => {
    return api.post(`/route/complete`, JSON.stringify(params));
};

export const dropersDropdownApi = (params) => {
    return api.get(`/route/dropers-list`, { params });
};

export const storesDropdownApi = (params) => {
    return api.get(`/route/stores-list`, { params });
};